// The Sangly boar (sanglier) mascot - 3/4 cartoon head.
// Keep in sync with public/favicon.svg.
export default function BoarMark({ size = 32, className = '', rounded = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className}
         role="img" aria-label="Sangly">
      <defs>
        <linearGradient id="sg-bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#7C6CF6" />
          <stop offset="1" stopColor="#5B45E0" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx={rounded} fill="url(#sg-bg)" />
      {/* ears */}
      <path d="M22 23 C18 12 23 7 28 11 C30 14 30 19 29 24 Z" fill="#8A5A38" />
      <path d="M24.5 22 C22.5 15 25 12 27.5 14 C29 17 28.5 20 27.5 23 Z" fill="#DE949B" />
      <path d="M42 21 C45 8 52 7 53 15 C53.5 20 50 24 46 24 Z" fill="#8A5A38" />
      <path d="M44 21 C46.5 12 50.5 12 51 16.5 C51 20.5 49 23 46 23 Z" fill="#DE949B" />
      {/* head + muzzle */}
      <path d="M22 22 C31 16 41 17 46 24 C48 27 49 30 50 33 C54 34 59 36 59 40 C59 44 56 47 51 47 C49 50 46 51 43 51 C41 55 38 57 34 56 C27 56 22 52 20 46 C17 41 17 33 18 28 C19 24 20 22 22 22 Z" fill="#9E6A43" />
      {/* mane */}
      <path d="M19 26 L21 13 L25.5 21 L30 12 L34 21 L38 13 L41 23 C42 29 40 37 35 41 C29 42 23 40 19 35 C17 31 17.5 28 19 26 Z" fill="#5C3B26" />
      {/* goatee */}
      <path d="M34 50 C33 55 32 60 34.5 63.5 C35.5 61 36.3 59 37 57 C38 60 40 62.5 42.5 61.5 C44.5 57 44 51.5 40.5 49 C38.5 51 36 51.5 34 50 Z" fill="#5C3B26" />
      {/* snout */}
      <ellipse cx="53.2" cy="41" rx="6.9" ry="5.5" fill="#BC8067" />
      <ellipse cx="50.6" cy="41" rx="1.5" ry="2.4" fill="#4A2C20" />
      <ellipse cx="55.4" cy="41" rx="1.5" ry="2.4" fill="#4A2C20" />
      {/* tusk */}
      <path d="M47 50.5 C43.3 48 42.3 41.8 45.5 38 C47.6 41 47 46.7 50.7 49.3 Z" fill="#F5EEDD" stroke="#CBB086" strokeWidth="0.7" />
      {/* eyes */}
      <circle cx="31" cy="30" r="2.8" fill="#FFFFFF" />
      <circle cx="41" cy="29.5" r="3.3" fill="#FFFFFF" />
      <circle cx="31.6" cy="30.2" r="1.5" fill="#241A12" />
      <circle cx="41.8" cy="29.8" r="1.8" fill="#241A12" />
      {/* eyebrows */}
      <path d="M27.6 25 Q31 22.8 34.2 25" fill="none" stroke="#4A2E1C" strokeWidth="2.2" strokeLinecap="round" />
      <path d="M37 24 Q41 21.6 45 24.2" fill="none" stroke="#4A2E1C" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}
